import React, { useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { useIntl } from "react-intl";

export default function BMEProductTree({
  productTree,
  loading,
  selectedProducts,
  handleProductSelection,
  selectedGroups,
  handleGroupSelection,
  selectedSeries,
  handleSeriesSelection,
  selectedCatalogues,
  handleCatalogueSelection,
}) {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (id, type) => {
    setExpanded((prev) => ({ ...prev, [`${type}-${id}`]: !prev[`${type}-${id}`] }));
  };

  const getSeriesProductCodes = (series) => {
    return series.products.map((product) => product.productCode);
  };

  const getGroupProductCodes = (group) => {
    return Object.values(group.series).flatMap((series) => getSeriesProductCodes(series));
  };

  const getCatalogueProductCodes = (catalogue) => {
    return Object.values(catalogue.groups).flatMap((group) => getGroupProductCodes(group));
  };

  const intl = useIntl();

  return (
    <>
      {productTree.length > 0 ? (
        productTree.map((catalogue) => (
          <div key={catalogue.catalogueId} className="mb-2 pb-2 pl-3 border-bottom border-gray">
            <FormGroup className="mb-1">
              <Input
                type="checkbox"
                id={`catalogue-${catalogue.catalogueId}`}
                checked={!!selectedCatalogues[catalogue.catalogueId]}
                onChange={(e) => {
                  handleCatalogueSelection(catalogue.catalogueId, e.target.checked);
                  Object.values(catalogue.groups).forEach((group) => {
                    handleGroupSelection(group.groupDescription, catalogue.catalogueId, e.target.checked);
                    Object.values(group.series).forEach((series) => {
                      handleSeriesSelection(series.seriesId, catalogue.catalogueId, group.groupDescription, e.target.checked);
                      getSeriesProductCodes(series).forEach((productCode) => {
                        handleProductSelection(productCode, e.target.checked);
                      });
                    });
                  });
                }}
                disabled={loading}
              />
              <Label
                className="ml-2 font-weight-bold cursor-pointer"
                onClick={() => {
                  toggleExpand(catalogue.catalogueId, "catalogue");
                }
            }
                style={{ cursor: "pointer", fontSize: "small" }}
              >
                {expanded[`catalogue-${catalogue.catalogueId}`] ? "▼" : "▶"} {catalogue.catalogueDescription}
              </Label>
            </FormGroup>
            {expanded[`catalogue-${catalogue.catalogueId}`] && (
              <div className="ml-3">
                {Object.values(catalogue.groups).map((group) => (
                  <div key={group.groupDescription} className="mb-1">
                    <FormGroup className="mb-1">
                      <Input
                        type="checkbox"
                        id={`group-${catalogue.catalogueId}-${group.groupDescription}`}
                        checked={!!selectedGroups[`${catalogue.catalogueId}-${group.groupDescription}`]}
                        onChange={(e) => {
                          handleGroupSelection(group.groupDescription, catalogue.catalogueId, e.target.checked);
                          Object.values(group.series).forEach((series) => {
                            handleSeriesSelection(series.seriesId, catalogue.catalogueId, group.groupDescription, e.target.checked);
                            getSeriesProductCodes(series).forEach((productCode) => {
                              handleProductSelection(productCode, e.target.checked);
                            });
                          });
                        }}
                        disabled={loading}
                      />
                      <Label
                        className="ml-2 font-weight-semibold cursor-pointer"
                        onClick={() => {
                          toggleExpand(group.groupDescription, "group");                       
                        }}
                        style={{ cursor: "pointer", fontSize: "small" }}
                      >
                        {expanded[`group-${group.groupDescription}`] ? "▼" : "▶"} {group.groupDescription}
                      </Label>
                    </FormGroup>
                    {expanded[`group-${group.groupDescription}`] && (
                      <div className="ml-3">
                        {Object.values(group.series).map((series) => (
                          <div key={series.seriesId} className="mb-1">
                            <FormGroup className="mb-1">
                              <Input
                                type="checkbox"
                                id={`series-${series.seriesId}`}
                                checked={!!selectedSeries[`${catalogue.catalogueId}-${group.groupDescription}-${series.seriesId}`]}
                                onChange={(e) => {
                                  handleSeriesSelection(series.seriesId, catalogue.catalogueId, group.groupDescription, e.target.checked);
                                  getSeriesProductCodes(series).forEach((productCode) => {
                                    handleProductSelection(productCode, e.target.checked);
                                  });
                                }}
                                disabled={loading}
                              />
                              <Label
                                className="ml-2 cursor-pointer"
                                onClick={() => {
                                  toggleExpand(series.seriesId, "series");                              
                                }}
                                style={{ cursor: "pointer", fontSize: "small" }}
                              >
                                {expanded[`series-${series.seriesId}`] ? "▼" : "▶"} {series.seriesName}
                              </Label>
                            </FormGroup>
                            {expanded[`series-${series.seriesId}`] && (
                              <div className="ml-3">
                                {series.products.map((product) => (
                                  <FormGroup key={product.productCode} className="mb-1">
                                    <Input
                                      type="checkbox"
                                      id={`product-${product.productCode}`}
                                      checked={!!selectedProducts[product.productCode]}
                                      onChange={(e) => handleProductSelection(product.productCode, e.target.checked)}
                                      disabled={loading}
                                    />
                                    <Label
                                      for={`product-${product.productCode}`}
                                      className="ml-2 cursor-pointer"
                                       style={{ cursor: "pointer", fontSize: "small" }}
                                    >
                                      {product.productName}
                                    </Label>
                                  </FormGroup>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="text-muted">{intl.formatMessage({id:"etim.no_products", defaultMessage:"No products available. Please select company and language."})}</p>
      )}
    </>
  );
}
